import React from "react";
import {Stack, Paper, Typography, Box} from "@mui/material";
import EventBusyIcon from '@mui/icons-material/EventBusy'; // Nebo jiná vhodná ikona

const EmptyRacesState: React.FC = () => (
    <Stack
        alignItems="center"
        justifyContent="flex-start"
        sx={{
            width: '100%',
            height: '100%',
        }}
    >
        <Paper
            elevation={2}
            sx={{
                p: {xs: 3, sm: 5},
                width: '85%',
                height: '70%',
                borderRadius: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
            }}
        >
            <Box>
                <EventBusyIcon sx={{fontSize: 56, color: 'grey.400'}}/>
            </Box>
            <Typography variant="h6" color="text.secondary" align="center">
                V této sezóně zatím nebyly zveřejněny žádné závody.
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
                Sledujte tuto stránku, informace k závodům budou brzy přidány.
            </Typography>
        </Paper>
    </Stack>
);

export default EmptyRacesState;
